export const PERMISSIONS = [
    {
      title: `No access`,
      permissions_level: 0,
      description: `None`,
    },
    {
      title: `Can view`,
      permissions_level: 1,
      description: `Can't edit or share with others`,
    },
    {
      title: `Can edit`,
      permissions_level: 2,
      description: `Can view & edit but can't share with others`,
    },
    {
      title: `Full access`,
      permissions_level: 3,
      description: `Can view & edit, can share with others`,
    },
  ];
  
  export const SHARE_ACTION = {
    USERS: "Users",
    TEAMS: "Teams",
  };
  export enum ACCESS_LEVEL {
    FULL_ACCESS = 3,
    CAN_EDIT = 2,
    CAN_VIEW = 1,
    NONE = 0,
  }
  export enum INVITE_USER_STATUS {
    SENT = "SENT",
    JOINED = "JOINED",
  }
  